export default class Gnav {
    constructor() {
        this.init();
    }

    init() {
        this.scrolled_y = window.pageYOffset;
        this.scrolled_top = this.scrolled_y;

        this.gnavOpen();
    }

    gnavOpen() {
        const trigger = document.querySelector('.js-gnavtrigger');
        const gnavItem = [...document.querySelectorAll('.l-gnav__item')];

        trigger.addEventListener('click', () => {
            document.body.classList.toggle('-gnav_active');
        });

        gnavItem.forEach((el) => {
            el.addEventListener('click', () => {
                document.body.classList.remove('-gnav_active');
            });
        });
    }

}
